module.exports = "<svg viewBox=\"0 0 32 22\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 2a2 2 0 012-2h28a2 2 0 012 2v18a2 2 0 01-2 2H2a2 2 0 01-2-2z\" fill=\"#0073b1\"></path><path d=\"M16.5 16h-1a.5.5 0 01-.5-.5V12h-3.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H15V6.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V10h3.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H17v3.5a.5.5 0 01-.5.5z\" fill=\"#fff\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/credit-cards/asda-credit-card-add-new.svg
// module id = 656
// module chunks = 0